export const SHARED_KEYS = {
  IS_LIVE: 'is_live',
  SWITCH_DASHBOARDS_INTERFACE: 'sdi',
};

export const TRANSACTIONS_KEYS = {
  PAYMENT_LINK_ID: 'payment_link_id',
  TRANSFER_ID: 'transfer_id',
};

export const SEARCH_PARAMS_KEYS = {
  ...SHARED_KEYS,
  ...TRANSACTIONS_KEYS,
};